import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHome from "./adminpages/AdminHome";
import Profile from "./Profile";
import Lightgallery from "./adminpages/Lightgallery";
import Gallery from "./adminpages/Gallery";
import UserHome from "./UserHome";
import Login from "./Userpages/Login";
import UserAbout from "./UserAbout";
import UserAbout2 from "./UserAbout2";
import UserContact from "./Userpages/UserContact";
import Productcentred from "./Userpages/Product-centred";
import Productextended from "./Userpages/Productextended";
import Productextendedgallery from "./Userpages/Productextendedgallery";
import Productsticky from "./Userpages/Productsticky";
import Productsidebar from "./Userpages/Productsidebar";
import Productfullwidth from "./Userpages/Productfullwidth";
import Productmansonry from "./Userpages/Productmansonry";
import Product from "./Userpages/Product";
import Newindex from "./Userpages/Newindex";
import Index1 from "./Userpages/Index1";
import Index2 from "./Userpages/Index2";
import Index3 from "./Userpages/Index3";
import Index4 from "./Userpages/Index4";
import Index5 from "./Userpages/Index5";
import Index7 from "./Userpages/Index7";
import Index8 from "./Userpages/Index8";
import Index9 from "./Userpages/Index9";
import Index10 from "./Userpages/Index10";
import Index11 from "./Userpages/Index11";
import Index12 from "./Userpages/Index12";
import Index13 from "./Userpages/Index13";
import Index15 from "./Userpages/Index15";
import Index14 from "./Userpages/Index14";
import Index16 from "./Userpages/Index16";
import Index17 from "./Userpages/Index17";
import Index18 from "./Userpages/Index18";
import Index19 from "./Userpages/Index19";
import Index20 from "./Userpages/Index20";
import Index21 from "./Userpages/Index21";
import Index22 from "./Userpages/Index22";
import Index6 from "./Userpages/Index6";
import Single from "./Userpages/Single";
import Checkout from "./Userpages/Checkout";
import Cart from "./Userpages/Cart";
import Wishlist from "./Userpages/Wishlist";
import Ladies from "./Userpages/Ladies";
import Quickview from "./Userpages/Quickview";
import Adminlogin from "./Userpages/Adminlogin";


function App() {
  return (
    <div>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UserHome/>}></Route>
          <Route path="/adminhome" element={<AdminHome />}></Route>
          <Route path="/userabout" element={<UserAbout/>}></Route>
          <Route path="/productcentred" element={<Productcentred/>}></Route>
          <Route path="/productextended" element={<Productextended/>}></Route>
          <Route path="/productextendedgallery" element={<Productextendedgallery/>}></Route>
          <Route path="/productsticky" element={<Productsticky/>}></Route>
          <Route path="/userabout2" element={<UserAbout2/>}></Route>
          <Route path="/usercontact" element={<UserContact/>}></Route>
          <Route path="/login" element={<Login/>}></Route>
          <Route path="/profile" element={<Profile/>}></Route>
          <Route path="/lightgallery" element={<Lightgallery/>}></Route>
          <Route path="/gallery" element={<Gallery/>}></Route>
          <Route path="/productsidebar" element={<Productsidebar/>}></Route>
          <Route path="/productfullwidth" element={<Productfullwidth/>}></Route>
          <Route path="/productmansonry" element={<Productmansonry/>}></Route>
          <Route path="/product" element={<Product/>}></Route>
          <Route path="/newindex" element={<Newindex/>}></Route>
          <Route path="/index1" element={<Index1/>}></Route>
          <Route path="/index2" element={<Index2/>}></Route>
          <Route path="/index3" element={<Index3/>}></Route>
          <Route path="/index4" element={<Index4/>}></Route>
          <Route path="/index5" element={<Index5/>}></Route>
          <Route path="/index6" element={<Index6/>}></Route>
          <Route path="/index7" element={<Index7/>}></Route>
          <Route path="/index8" element={<Index8/>}></Route>
          <Route path="/index9" element={<Index9/>}></Route>
          <Route path="/index10" element={<Index10/>}></Route>
          <Route path="/index11" element={<Index11/>}></Route>
          <Route path="/index12" element={<Index12/>}></Route>
          <Route path="/index13" element={<Index13/>}></Route>
          <Route path="/index14" element={<Index14/>}></Route>
          <Route path="/index15" element={<Index15/>}></Route>
          <Route path="/index16" element={<Index16/>}></Route>
          <Route path="/index17" element={<Index17/>}></Route>
          <Route path="/index18" element={<Index18/>}></Route>
          <Route path="/index19" element={<Index19/>}></Route>
          <Route path="/index20" element={<Index20/>}></Route>
          <Route path="/index21" element={<Index21/>}></Route>
          <Route path="/index22" element={<Index22/>}></Route>
          <Route path="/single" element={<Single/>}></Route>
          <Route path="/checkout" element={<Checkout/>}></Route>
          <Route path="/cart" element={<Cart/>}></Route>
          <Route path="/wishlist" element={<Wishlist/>}></Route>
          <Route path="/ladies" element={<Ladies/>}></Route>
          <Route path="/quickview" element={<Quickview/>}></Route>
          <Route path="/adminlogin" element={<Adminlogin/>}></Route>
          
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
